import React from 'react';
import {Images,TextArea,Page} from '../index';
import {Btn} from '../../Common/index';
import styled from 'styled-components';
import comic1 from '../../../asset/img/comic/other/comic13_1.png';
import comic2 from '../../../asset/img/comic/other/comic13_2.png';

const H2 = styled.h2`
 font-size: 2em;
 `

const Story16 = () => {
    return(
        <div className="common__item">
        <div className="common__center">
  <H2>相良ヨシヒのグチ</H2>
  <Images 
  image_1= {comic1}
  image_2= {comic2}
  style3= "display-none"
   alt_1= "相良ヨシヒのグチ"
   alt_2= "相良ヨシヒのグチ"
  />
  <TextArea 
   text1="「相良義陽」は現在「肥後」の戦国大名です。"
   text2="九州の脅威的な勢力図の中「義陽」は努力があり「足利義輝」に「官位」を獲得"
   text3="しかし、これが原因で「大友家」「島津家」から大ブーイング!!"
   data="2018/07-28"
  />
  <Btn
   text="一覧に戻る"
   link="/comic"
  />
 </div>
 </div>
    )
}
export default Story16;